import { throwError as observableThrowError, Observable } from 'rxjs';

import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';


import { ServiceBase } from '@app/services/base.service';
import { NotaFiscal } from '@app/models/nota-fiscal.model';
import { PesquisaFiltro } from '@app/pages/financeiro/nota-fiscal/nota-fiscal-lista/pesquisa-filtro.model';
import { CancelamentoModel } from '@app/pages/financeiro/nota-fiscal/nota-fiscal-lista/cancelamento.model';

@Injectable()
export class NotaFiscalService extends ServiceBase{
    constructor(private http: HttpClient) {
        super();
    }

    obterPorId(id: number){
        return this.http.get<any>(this.URL_API + `financeiro/nota-fiscal/${id}`).pipe(
            catchError((error: any) => observableThrowError(error)));
    }

    gravar(nota: NotaFiscal){
        return this.http.post<any>(this.URL_API + 'financeiro/nota-fiscal', nota).pipe(
                catchError((error: any) => observableThrowError(error)));
    }

    cancelar(cancelamento: CancelamentoModel){
        return this.http.post<any>(this.URL_API + 'financeiro/nota-fiscal/cancelar', cancelamento).pipe(
                catchError((error: any) => observableThrowError(error)));
    }

    consultar(uuid: string, id: number){
        return this.http.get<any>(this.URL_API + `financeiro/nota-fiscal/consultarStatus/${uuid}/${id}`).pipe(
                catchError((error: any) => observableThrowError(error)));
    }

    lista(pesquisa: PesquisaFiltro){
        return this.http.post<any>(this.URL_API + 'financeiro/nota-fiscal/lista', pesquisa).pipe(
                catchError((error: any) => observableThrowError(error)));
    }

    buscarClasseImposto(){
        return this.http.get<any>(this.URL_API + 'financeiro/nota-fiscal/classe-imposto').pipe(
            catchError((error: any) => observableThrowError(error)));
    }
}